jQuery(document).ready(function TopBar($) {
	var $window = $(window);
	var $topBar = $('.nav-top');
	var check = function() {
		if($window.scrollTop() > 50) {
			if(!$topBar.hasClass('nav-top--fixed-in')) {
				$topBar.addClass('nav-top--fixed-in')
			}
			
			if($topBar.hasClass('nav-top--fixed-out')) {
				$topBar.removeClass('nav-top--fixed-out')
			}
			$topBar.addClass('nav-top--fixed-in').removeClass('nav-top--fixed-out');
		} else {
			if($topBar.hasClass('nav-top--fixed-in')) {
				$topBar.removeClass('nav-top--fixed-in')
				
				if(!$topBar.hasClass('nav-top--fixed-out')) {
					$topBar.addClass('nav-top--fixed-out')
				}
			}
			
		}
	};
	
	$window.on('scroll', function(e) {
		check.call(this);
	});
	
	check.call(window);
});